<template>
  <el-dialog
    :title="dialogType === 'create' ? 'Ár hozzáadása' : 'Ár szerkesztése'"
    :append-to-body="true"
    :visible="visible"
    :close-on-click-modal="false"
    width="350px"
    @open="onOpen"
    @close="$emit('close')"
  >
    <el-form
      v-loading="loading"
      ref="form"
      :model="item"
      label-position="top"
    >
      <el-form-item
        v-if="itemType === 'product'"
        label="Termék"
      >
        <el-select
          v-model="item.product_id"
          filterable
          :remote="true"
          :remote-method="value => search('products', `?name=${value}&status=active`)"
          :loading="productsLoading"
          placeholder="Gépelj a kereséshez..."
          loading-text="Termékek betöltése..."
          style="width: 100%;"
          @change="onProductChange"
        >
          <el-option
            v-for="p in products"
            :key="p.id"
            :value="p.id"
            :label="p.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Ár"
      >
        <el-input-localized-numeric
          v-model="item.price"
          @change="onPriceChange"
        >
          <template slot="append">Ft</template>
        </el-input-localized-numeric>
      </el-form-item>
      <el-form-item
        label="Jutalék számítás"
      >
        <el-select
          v-model="item.commission_price_type_id"
          filterable
          clearable
          style="width: 100%;"
          placeholder="Egyedi áras"
        >
          <el-option
            v-for="p in priceTypes"
            :key="p.id"
            :value="p.id"
            :label="p.name"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="store">{{ dialogType === 'create' ? 'Hozzáadás' : 'Mentés'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import measureUnits from '../../measureUnits';

export default {
  props: ['visible', 'currency', 'defaultItem', 'customerId'],
  data() {
    return {
      measureUnits,
      itemType: 'product',
      item: {
        unit_of_measure: 'PIECE'
      },
      dialogType: 'create',
      productsLoading: false,
      suppliersLoading: false,
      servicesLoading: false,
      packLoading: false,
      priceLoading: false,
      vatLoading: false,
      loading: false,
      originalUnitPrice: 0,
      products: [],
      services: [],
      suppliers: [],
      packTypes: [],
      vats: [],
    };
  },
  computed: {
    netPrice() {
      return this.item.unit_price * this.item.count;
    },
    grossPrice() {
      return this.netPrice * (1 + this.item.vat / 100);
    },
    priceTypes() {
      return this.$store.getters['priceType/priceTypes'];
    },
  },
  async mounted() {
    if (!this.priceTypes.length) {
      await this.$store.dispatch('priceType/fetchAll');
    }
  },
  methods: {
    onPriceChange(value) {
      this.item.price = parseFloat(value)
    },
    async store() {
      this.item.supplier_name = this.item.supplier_id ? this.suppliers.find(partner => partner.id === this.item.supplier_id).name : null;
      let lineItemName = this.item.product_name;
      if (this.item.product_id && this.itemType === 'product') {
        this.item.service_id = null;
        lineItemName = this.products.find(product => product.id === this.item.product_id).name;
      }
      if (this.item.service_id && this.itemType === 'service') {
        this.item.product_id = null;
        this.item.supplier_id = null;
        this.item.supplier_name = null;
        lineItemName = this.services.find(service => service.id === this.item.service_id).name;
      }
      if (this.itemType === 'free') {
        this.item.product_id = null;
        this.item.service_id = null;
        this.item.supplier_id = null;
        this.item.supplier_name = null;
      }
      this.item.product_name = lineItemName;
      this.item.net_price = this.item.unit_price * this.item.count;
      this.item.gross_price = this.item.net_price * (1 + this.item.vat / 100);
      this.$emit('change', this.item);
      this.$emit('close');
    },
    onPackChange(value) {
      const pack = this.packTypes.find(p => p.id === value);
      if (pack) {
        this.$set(this.item, 'unit_of_measure', pack.count_per_pack === 1 ? 'PIECE' : 'CARTON');
        this.$set(this.item, 'unit_price', this.originalUnitPrice * pack.count_per_pack);
      }
    },
    async getPacks() {
      this.packLoading = true;
      this.packTypes = await axios.get(`api/product-pack-types/${this.item.product_id}`);
      this.$set(this.item, 'product_pack_type_id', this.packTypes.find(packType => packType.count_per_pack === 1).id);
      this.packLoading = false;
    },
    async onProductChange(value) {
      this.getPacks();
      this.setProductVat();
      this.setProductPrice();
      this.setSuppliers();
    },
    async setProductVat() {
      this.vatLoading = true;
      const vat = await axios.get(`api/vats/product/${this.item.product_id}`);
      this.$set(this.item, 'vat', vat);
      this.vatLoading = false;
    },
    async setSuppliers() {
      this.suppliersLoading = true;
      const suppliers = await axios.get(`api/search/suppliers/${this.item.product_id}`);
      this.suppliers = suppliers;
      if (suppliers && suppliers.length) {
        this.$set(this.item, 'supplier_id', suppliers[0].id);
      }
      this.suppliersLoading = false;
    },
    async setProductPrice() {
      this.priceLoading = true;
      const price = await axios.get(`api/customer-price-lists/partner/${this.customerId}/product/${this.item.product_id}`);
      this.originalUnitPrice = price;
      this.$set(this.item, 'unit_price', price);
      this.priceLoading = false;
    },
    setSupplier(value) {
      console.log(value);
    },
    async onOpen() {
      this.loading = true;
      this.setItem();
      if (this.item.key || this.item.id) {
        this.itemType = this.item.product_id ? 'product' : (this.item.service_id ? 'service' : 'free');
        this.dialogType = 'update';
      } else {
        this.itemType = 'product';
        this.dialogType = 'create';
      }
      if (this.item.product_id) {
        this.products = [{ id: this.item.product_id, name: this.item.product_name }];
      }
      if (this.item.service_id) {
        this.products = [{ id: this.item.service_id, name: this.item.product_name }];
      }
      if (this.item.supplier_id) {
        this.suppliers = [{ id: this.item.supplier_id, name: this.item.supplier_name }];
      }
      if (this.vats.length === 0) {
        this.vats = await axios.get('api/search/vats');
        if (this.item.product_id) {
          const vat = await axios.get(`api/vats/product/${this.item.product_id}`);
          this.$set(this.item, 'vat', vat);
        }
      }
      this.loading = false;
    },
    setItem() {
      this.item = { ...this.defaultItem };
    },
    async search(resource, query) {
      if (query !== '') {
        this[`${resource}Loading`] = true;
        this[resource] = await axios.get(`api/search/${resource}${query}`);
        this[`${resource}Loading`] = false;
      }
    },
  },
};
</script>
